// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const AddProductForm = () => {
//   const [name, setName] = useState("");
//   const [subcategoryId, setSubcategoryId] = useState("");
//   const [subcategories, setSubcategories] = useState([]);
//   const [branches, setBranches] = useState([]);
//   const [variants, setVariants] = useState([]);
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     axios.get("https://agaram.ematixsolutions.com/api/subcategories").then((res) => {
//       setSubcategories(res.data || []);
//     });
//     axios.get("https://agaram.ematixsolutions.com/api/branches").then((res) => {
//       setBranches(res.data || []);
//     });
//   }, []);

//   const handleAddVariant = () => {
//     setVariants([
//       ...variants,
//       {
//         size: "",
//         unit: "",
//         mrp: "",
//         rate: "",
//         stocks: [{ branch_id: "", stock: "" }],
//       },
//     ]);
//   };

//   const handleAddStock = (variantIndex) => {
//     const newVariants = [...variants];
//     newVariants[variantIndex].stocks.push({ branch_id: "", stock: "" });
//     setVariants(newVariants);
//   };

//   const handleStockChange = (variantIndex, stockIndex, key, value) => {
//     const newVariants = [...variants];
//     newVariants[variantIndex].stocks[stockIndex][key] = value;
//     setVariants(newVariants);
//   };

//   const handleSubmit = async () => {
//     if (loading) return;
//     setLoading(true);

//     const formData = new FormData();
//     formData.append("name", name);
//     formData.append("subcategory_id", subcategoryId);

//     variants.forEach((variant, i) => {
//       formData.append(`variants[${i}][size]`, variant.size);
//       formData.append(`variants[${i}][unit]`, variant.unit);
//       formData.append(`variants[${i}][mrp]`, variant.mrp);
//       formData.append(`variants[${i}][rate]`, variant.rate);

//       variant.stocks.forEach((stock, j) => {
//         formData.append(`variants[${i}][stocks][${j}][branch_id]`, stock.branch_id);
//         formData.append(`variants[${i}][stocks][${j}][stock]`, stock.stock);
//       });
//     });

//     images.forEach((img, i) => {
//       formData.append(`images[${i}]`, img);
//     });

//     try {
//       await axios.post("https://agaram.ematixsolutions.com/api/products", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       alert("Product added successfully");
//       navigate("/dashboard");

//       setName("");
//       setSubcategoryId("");
//       setVariants([]);
//       setImages([]);
//     } catch (err) {
//       console.error(err);
//       alert("Error adding product");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const styles = {
//     container: {
//       maxWidth: "600px",
//       margin: "0 auto",
//       padding: "20px",
//       border: "1px solid #ddd",
//       borderRadius: "8px",
//       backgroundColor: "#fff",
//       boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       marginBottom: "20px",
//       textAlign: 'center',
//         color: '#006666',
//     },
//     input: {
//       width: "100%",
//       padding: "10px",
//       marginBottom: "12px",
//       borderRadius: "4px",
//       border: "1px solid #ccc",
//     },
//     select: {
//       width: "100%",
//       padding: "10px",
//       marginBottom: "12px",
//       borderRadius: "4px",
//       border: "1px solid #ccc",
//     },
//     button: {
//       padding: "10px 16px",
//       borderRadius: "4px",
//       border: "none",
//       backgroundColor: "#28a745",
//       color: "#fff",
//       cursor: "pointer",
//       marginTop: "10px",
//     },
//     variantBox: {
//       border: "1px solid #ccc",
//       padding: "10px",
//       borderRadius: "6px",
//       marginBottom: "16px",
//       backgroundColor: "#f9f9f9",
//     },
//     stockRow: {
//       display: "flex",
//       gap: "10px",
//       marginBottom: "10px",
//     },
//     smallButton: {
//       color: "#007bff",
//       background: "none",
//       border: "none",
//       cursor: "pointer",
//       fontSize: "14px",
//       padding: "0",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>Add Product</h2>

//       <input
//         type="text"
//         placeholder="Product Name"
//         value={name}
//         onChange={(e) => setName(e.target.value)}
//         style={styles.input}
//       />

//       <select
//         value={subcategoryId}
//         onChange={(e) => setSubcategoryId(e.target.value)}
//         style={styles.select}
//       >
//         <option value="">Select Subcategory</option>
//         {subcategories.map((sub) => (
//           <option key={sub.id} value={sub.id}>
//             {sub.name}
//           </option>
//         ))}
//       </select>

//       {variants.map((v, index) => (
//         <div key={index} style={styles.variantBox}>
//           <input
//             type="text"
//             placeholder="Size"
//             value={v.size}
//             onChange={(e) => {
//               const updated = [...variants];
//               updated[index].size = e.target.value;
//               setVariants(updated);
//             }}
//             style={styles.input}
//           />
//           <input
//             type="text"
//             placeholder="Unit"
//             value={v.unit}
//             onChange={(e) => {
//               const updated = [...variants];
//               updated[index].unit = e.target.value;
//               setVariants(updated);
//             }}
//             style={styles.input}
//           />
//           <input
//             type="text"
//             placeholder="MRP"
//             value={v.mrp}
//             onChange={(e) => {
//               const updated = [...variants];
//               updated[index].mrp = e.target.value;
//               setVariants(updated);
//             }}
//             style={styles.input}
//           />
//           <input
//             type="text"
//             placeholder="Rate"
//             value={v.rate}
//             onChange={(e) => {
//               const updated = [...variants];
//               updated[index].rate = e.target.value;
//               setVariants(updated);
//             }}
//             style={styles.input}
//           />

//           <div>
//             {v.stocks.map((stock, sIdx) => (
//               <div key={sIdx} style={styles.stockRow}>
//                 <select
//                   value={stock.branch_id}
//                   onChange={(e) =>
//                     handleStockChange(index, sIdx, "branch_id", e.target.value)
//                   }
//                   style={styles.select}
//                 >
//                   <option value="">Select Branch</option>
//                   {branches.map((b) => (
//                     <option key={b.id} value={b.id}>
//                       {b.name}
//                     </option>
//                   ))}
//                 </select>
//                 <input
//                   type="number"
//                   placeholder="Stock"
//                   value={stock.stock}
//                   onChange={(e) =>
//                     handleStockChange(index, sIdx, "stock", e.target.value)
//                   }
//                   style={styles.input}
//                 />
//               </div>
//             ))}
//             <button
//               type="button"
//               style={styles.smallButton}
//               onClick={() => handleAddStock(index)}
//             >
//               + Add Stock Entry
//             </button>
//           </div>
//         </div>
//       ))}

//       <button
//         type="button"
//         onClick={handleAddVariant}
//         style={{ ...styles.button, backgroundColor: "#007bff" }}
//       >
//         + Add Variant
//       </button>

//       <input
//         type="file"
//         multiple
//         onChange={(e) => setImages([...e.target.files])}
//         style={{ marginTop: "12px", marginBottom: "12px" }}
//       />

//       <button
//         onClick={handleSubmit}
//         disabled={loading}
//         style={{
//           ...styles.button,
//           backgroundColor: loading ? "#ccc" : "#28a745",
//           cursor: loading ? "not-allowed" : "pointer",
//         }}
//       >
//         {loading ? "Submitting..." : "Submit Product"}
//       </button>
//     </div>
//   );
// };

// export default AddProductForm;

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddProductForm = () => {
  const [name, setName] = useState("");
  const [code, setCode] = useState(""); // New state for product code
  const [subcategoryId, setSubcategoryId] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [branches, setBranches] = useState([]);
  const [variants, setVariants] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("https://agaram.ematixsolutions.com/api/subcategories").then((res) => {
      setSubcategories(res.data || []);
    });
    axios.get("https://agaram.ematixsolutions.com/api/branches").then((res) => {
      setBranches(res.data || []);
    });
  }, []);

  const handleAddVariant = () => {
    setVariants([
      ...variants,
      {
        size: "",
        unit: "",
        mrp: "",
        rate: "",
        stocks: [{ branch_id: "", stock: "" }],
      },
    ]);
  };

  const handleAddStock = (variantIndex) => {
    const newVariants = [...variants];
    newVariants[variantIndex].stocks.push({ branch_id: "", stock: "" });
    setVariants(newVariants);
  };

  const handleStockChange = (variantIndex, stockIndex, key, value) => {
    const newVariants = [...variants];
    newVariants[variantIndex].stocks[stockIndex][key] = value;
    setVariants(newVariants);
  };

  const handleSubmit = async () => {
    if (loading) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("code", code); // Add product code to form data
    formData.append("subcategory_id", subcategoryId);

    variants.forEach((variant, i) => {
      formData.append(`variants[${i}][size]`, variant.size);
      formData.append(`variants[${i}][unit]`, variant.unit);
      formData.append(`variants[${i}][mrp]`, variant.mrp);
      formData.append(`variants[${i}][rate]`, variant.rate);

      variant.stocks.forEach((stock, j) => {
        formData.append(
          `variants[${i}][stocks][${j}][branch_id]`,
          stock.branch_id
        );
        formData.append(`variants[${i}][stocks][${j}][stock]`, stock.stock);
      });
    });

    images.forEach((img, i) => {
      formData.append(`images[${i}]`, img);
    });

    try {
      await axios.post("https://agaram.ematixsolutions.com/api/products", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Product added successfully");
      navigate("/dashboard");

      setName("");
      setCode("");
      setSubcategoryId("");
      setVariants([]);
      setImages([]);
    } catch (err) {
      console.error(err);
      alert("Error adding product");
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      maxWidth: "600px",
      margin: "0 auto",
      padding: "20px",
      border: "1px solid #ddd",
      borderRadius: "8px",
      backgroundColor: "#fff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: "center",
      color: "#006666",
    },
    input: {
      width: "100%",
      padding: "10px",
      marginBottom: "12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },
    select: {
      width: "100%",
      padding: "10px",
      marginBottom: "12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },
    button: {
      padding: "10px 16px",
      borderRadius: "4px",
      border: "none",
      backgroundColor: "#28a745",
      color: "#fff",
      cursor: "pointer",
      marginTop: "10px",
    },
    variantBox: {
      border: "1px solid #ccc",
      padding: "10px",
      borderRadius: "6px",
      marginBottom: "16px",
      backgroundColor: "#f9f9f9",
    },
    stockRow: {
      display: "flex",
      gap: "10px",
      marginBottom: "10px",
    },
    smallButton: {
      color: "#007bff",
      background: "none",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
      padding: "0",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Add Product</h2>

      <input
        type="text"
        placeholder="Product Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={styles.input}
      />

      <input
        type="text"
        placeholder="Product Code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        style={styles.input}
      />

      <select
        value={subcategoryId}
        onChange={(e) => setSubcategoryId(e.target.value)}
        style={styles.select}
      >
        <option value="">Select Subcategory</option>
        {subcategories.map((sub) => (
          <option key={sub.id} value={sub.id}>
            {sub.name}
          </option>
        ))}
      </select>

      {variants.map((v, index) => (
        <div key={index} style={styles.variantBox}>
          <input
            type="text"
            placeholder="Size"
            value={v.size}
            onChange={(e) => {
              const updated = [...variants];
              updated[index].size = e.target.value;
              setVariants(updated);
            }}
            style={styles.input}
          />
          <input
            type="text"
            placeholder="Unit"
            value={v.unit}
            onChange={(e) => {
              const updated = [...variants];
              updated[index].unit = e.target.value;
              setVariants(updated);
            }}
            style={styles.input}
          />
          <input
            type="text"
            placeholder="MRP"
            value={v.mrp}
            onChange={(e) => {
              const updated = [...variants];
              updated[index].mrp = e.target.value;
              setVariants(updated);
            }}
            style={styles.input}
          />
          <input
            type="text"
            placeholder="Rate"
            value={v.rate}
            onChange={(e) => {
              const updated = [...variants];
              updated[index].rate = e.target.value;
              setVariants(updated);
            }}
            style={styles.input}
          />

          <div>
            {v.stocks.map((stock, sIdx) => (
              <div key={sIdx} style={styles.stockRow}>
                <select
                  value={stock.branch_id}
                  onChange={(e) =>
                    handleStockChange(index, sIdx, "branch_id", e.target.value)
                  }
                  style={styles.select}
                >
                  <option value="">Select Branch</option>
                  {branches.map((b) => (
                    <option key={b.id} value={b.id}>
                      {b.name}
                    </option>
                  ))}
                </select>
                <input
                  type="number"
                  placeholder="Stock"
                  value={stock.stock}
                  onChange={(e) =>
                    handleStockChange(index, sIdx, "stock", e.target.value)
                  }
                  style={styles.input}
                />
              </div>
            ))}
            <button
              type="button"
              style={styles.smallButton}
              onClick={() => handleAddStock(index)}
            >
              + Add Stock Entry
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={handleAddVariant}
        style={{ ...styles.button, backgroundColor: "#007bff" }}
      >
        + Add Variant
      </button>

      <input
        type="file"
        multiple
        onChange={(e) => setImages([...e.target.files])}
        style={{ marginTop: "12px", marginBottom: "12px" }}
      />

      <button
        onClick={handleSubmit}
        disabled={loading}
        style={{
          ...styles.button,
          backgroundColor: loading ? "#ccc" : "#28a745",
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Submitting..." : "Submit Product"}
      </button>
    </div>
  );
};

export default AddProductForm;
